<template>
  <div class="row">
    <div class="col-xs-6 col-sm-6 start-xs start-sm" v-show="!loading">
      <div class="container-buttons" ref="headerDropdowns">
        <b-dropdown
          :text="selectedDropdownLeft"
          variant="primary"
          size="sm"
          v-show="!isVisibleMeasureChart"
        >
          <b-dropdown-item-button
            v-for="chart in colNames"
            :key="chart"
            @click="changeDropdownLeft(chart)"
            :disabled="selectedDropdownRight == chart"
          >
            {{ chart }}
          </b-dropdown-item-button>
        </b-dropdown>

        <b-dropdown
          :text="!selectedDropdownRight ? 'SELECIONAR' : selectedDropdownRight"
          variant="success"
          size="sm"
          class="ml-md-2"
          v-if="colNames.length > 1 && !isVisibleMeasureChart"
          :disabled="
            selectedDropdownLeft === 'm³' ||
            selectedDropdownLeft === 'mm' ||
            selectedDropdownLeft === 'kWh' ||
            selectedDropdownLeft === ' kVArh' ||
            isVisibleMeasureChart
          "
        >
          <b-dropdown-item-button
            v-for="(chart, i) in colNamesRight"
            :key="i"
            @click="selectedDropdownRight = chart"
            :disabled="
              chart == selectedDropdownLeft &&
              selectedDropdownLeft === colNamesRight[i]
            "
          >
            {{ chart }}
          </b-dropdown-item-button>
        </b-dropdown>
        <b-button
          variant="primary"
          v-if="isVisibleMeasureChart"
          size="sm"
          @click="resetChartMinMax"
        >
          <arrow-left-icon />
          Voltar
        </b-button>
      </div>
    </div>

    <div class="col-xs-6 col-sm-6 end-xs btn-left" v-show="!loading">
      <b-btn-group>
        <b-btn
          v-for="p in periods"
          :key="p"
          size="sm"
          variant="primary"
          @click="changeDataByPeriod(p)"
          :disabled="
            (!isVisibleMeasureChart && p == period) || measureChartType == 'avg'
          "
          >{{ p }}</b-btn
        >
      </b-btn-group>
    </div>
    <!-- Gráficos de medições específicas e Max/Min -->
    <div
      class="col-xs-12 center-xs grafics"
      v-if="isVisibleMeasureChart && hasMeasureChart && !loadingMeasureChart"
    >
      <apexchart
        v-if="hasMeasureChart"
        width="100%"
        height="425"
        :series="measureChartSeries"
        :options="measureChartOptions"
      ></apexchart>
    </div>

    <div
      class="col-xs-12 center-xs grafics"
      v-show="!hasMeasureChart && !isVisibleMeasureChart"
    >
      <div v-if="!hasChart && loading">
        <spinner /> Desenhando o gráfico. Por favor, aguarde...
      </div>
      {{ noChartWarning }}
      <apexchart
        v-if="hasChart"
        width="100%"
        height="425"
        :series="series"
        :options="options"
      ></apexchart>
    </div>

    <div
      class="col-xs-12 highlights ml-2 row"
      v-show="!hasMeasureChart && !isVisibleMeasureChart"
    >
      <div
        class="col-xs-12 p-0 row around-xs card-container"
        v-for="(highlight, index) in highlights"
        :key="index"
      >
        <h5
          class="col-xs-12 card-name p-1 m-0"
          :style="`background-color:${highlight.color};color:#fff`"
        >
          {{ highlight.name }}
        </h5>
        <div class="col-xs-6 col-sm-3 center-xs p-2">
          <div class="hl-data">
            <h4>{{ highlight.min }}</h4>
            <div class="hl-unit">{{ highlight.unit }}</div>
          </div>
          <div class="hl-">Mínimo</div>
          <span class="hl-detail">
            {{ formatDate(highlight.minDates) }}
          </span>
        </div>
        <div class="col-xs-6 col-sm-3 center-xs p-2">
          <div class="hl-data">
            <h4>{{ highlight.avg }}</h4>
            <div class="hl-unit">{{ highlight.unit }}</div>
          </div>
          <div class="hl-">Média</div>
          <span class="hl-detail">
            {{ highlight.length + " leituras" }}
          </span>
        </div>
        <div class="col-xs-6 col-sm-3 center-xs p-2">
          <div class="hl-data">
            <h4>{{ highlight.max }}</h4>
            <div class="hl-unit">{{ highlight.unit }}</div>
          </div>
          <div class="hl-">Máximo</div>
          <span class="hl-detail">
            {{ formatDate(highlight.maxDates) }}
          </span>
        </div>
        <!-- BOTÕES DE EXIBIÇÃO DE GRÁFICOS -->
        <div
          class="d-flex flex-column justify-content-around align-items-center col-xs-6 col-lg-3 col-sm-3 pt-2 mb-2"
        >
          <b-button
            size="sm"
            pill
            class=""
            variant="outline-secondary"
            @click="showMeasureChart(highlight.pos, highlight.unit)"
            v-show="highlights.length > 1"
          >
            <chart-bar />
            Ver Gráfico
          </b-button>

          <b-button
            size="sm"
            class=""
            pill
            variant="outline-secondary"
            @click="showMeasureChart(highlight.pos, highlight.unit, 'avg')"
            :disabled="items.FOLDER === 'hyd'"
          >
            <chart-bar />
            Ver Max/min
          </b-button>
        </div>
      </div>
    </div>
    <div
      class="col-xs-12 mt-2 mr-2"
      v-show="!hasMeasureChart && !isVisibleMeasureChart"
    >
      <TabulatorEvents
        v-if="eqp"
        :data="TabulatorData"
        :chart-mounted="isChartMounted"
        :on-create="createEvent"
      />
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { monitChart } from "@/api";
import {
  organizeLog,
  organizeLogMaxMin,
} from "@/pages/components/monit/charts";
const TabulatorEvents = () => ({
  component: import("../../../components/shared/TableEvents.vue"),
  delay: 100,
  timeout: 2000,
});

export default {
  name: "chart-line",
  components: {
    TabulatorEvents,
  },
  props: {
    eqp: String,
    name: String,
    colNames: Array,
    columns: Array,
    showAxesZero: {
      type: Boolean,
      value: false,
    },
    currentlyValues: Object,
    area: Number,
    items: [Object, Array],
  },
  data() {
    return {
      period: "7d",
      periods: ["30min", "1h", "1d", "3d", "7d"],
      loading: true,
      loadingMeasureChart: false,
      controller: null,
      noChartWarning: "",
      hasChart: false,
      hasMeasureChart: false,
      apex: null, //apex
      selectedDropdownLeft: null,
      isVisibleMeasureChart: false,
      //Opção para MAX e MIN
      measureChartPosition: null,
      measureChartUnit: null,
      measureChartType: null,
      selectedDropdownRight: null,
      isChartMounted: false,
      info: {},
      MeasureChartInfo: {},
      series: [],
      options: {},
      measureChartSeries: [],
      measureChartOptions: {},
      colNamesRight: [],
      colorChart: {
        type: "solid",
        opacity: 0.1,
        gradient: {
          type: "vertical",
          shade: "dark",
          shadeIntensity: 0.5,
          opacityFrom: 0.7,
          opacityTo: 0.3,
          stops: [0, 50, 100],
        },
      },
      TabulatorData: [],
    };
  },
  created() {
    this.selectedDropdownLeft = this.colNames[0];
    this.colNamesRight = this.colNames
      .map((e) => e)
      .filter((e) => e !== "m³" && e !== "mm" && e !== "kWh" && e !== "kVArh");
    this.colNamesRight.unshift("SELECIONAR");
    this.selectedDropdownRight = null;
    this.controller = new AbortController();
    if (this.eqp) this.callChart(this.eqp, this.name, this.columns);
    else {
      this.loading = false;
      this.hasChart = false;
      this.noChartWarning = "Não foi identificado o equipamento do gráfico.";
    }
  },
  beforeDestroy() {
    this.controller.abort();
    this.$emit("reset");
  },
  watch: {
    selectedDropdownRight(option) {
      if (this.period != "7d") {
        this.period = "7d";
      }
      if (option === "SELECIONAR") {
        if (this.series.length > 1) {
          this.selectedDropdownRight = null;
          this.buildChartForLeftSideDropdown();
        }
      } else if (option && this.series[0] && this.series[0].name) {
        this.buildChartForRightSideDropdown();
      }
    },
  },
  computed: {
    highlights() {
      let highlights = [];
      for (let i = 0; i < this.series.length; i++) {
        let pos = null;
        if (this.series[i].data && this.series[i].data.length) {
          let logs = this.series[i].data.map((e) => Number(e[1]));
          let max = Math.max(...logs);
          // let min = Math.min(...logs);
          let avg = 0;
          let min = 0;
          avg = (logs.reduce((acc, e) => acc + e, 0) / logs.length).toFixed(2);
          min = Math.min(...logs);
          let maxDates = this.series[i].data
            .filter((e) => e[1] == max)
            .map((e) => e[0]);
          let minDates = this.series[i].data
            .filter((e) => e[1] == min)
            .map((e) => e[0]);
          if (this.eqp == "SENSOR") {
            pos =
              Number(this.series[i].name.split(" - ")[0].match(/[0-9]+/g)[0]) -
              1;
          }
          if (
            highlights.push({
              name: this.series[i].name,
              unit: this.series[i].unit,
              pos,
              max,
              maxDates,
              min,
              minDates,
              avg,
              length: logs.length,
              color: this.series[i].c,
            }) == this.series.length
          ) {
            return highlights;
          }
        } else {
          if (
            highlights.push({
              name: this.series[i].name,
              unit: this.series[i].unit,
              pos,
              max: "?",
              maxDates: "",
              min: "?",
              minDates: "",
              avg: "?",
              length: "?",
              color: this.series[i].c,
            }) == this.series.length
          )
            return highlights;
        }
      }
    },
  },
  methods: {
    scrollToTop() {
      this.$refs.headerDropdowns.scrollIntoView(true);
    },
    showMeasureChart(position, unit, type = "measure") {
      this.scrollToTop();
      this.isVisibleMeasureChart = true;
      this.loadingMeasureChart = true;
      this.measureChartPosition = position;
      this.measureChartUnit = unit;
      this.measureChartType = type;
      setTimeout(this.createMeasureChart(), 180);
    },
    resetChartMinMax() {
      this.measureChartSeries = [];
      this.measureChartOptions = [];
      this.hasMeasureChart = false;
      this.measureChartPosition = null;
      this.measureChartUnit = null;
      this.measureChartType = null;
      this.isVisibleMeasureChart = false;
    },
    // selectedUnit, chartType = null,period=null
    buildMeasureChart(PERIOD = null) {
      let keys = Object.keys(this.MeasureChartInfo);
      if (keys.length && keys.includes("measuresPerUnit")) {
        let dataPerUnit =
          this.MeasureChartInfo.measuresPerUnit[this.measureChartUnit];
        let lenPerUnit =
          this.measureChartType === "avg" ? dataPerUnit[0].data.length : 1;
        let filter = 0;
        if (PERIOD) filter = this.getTimestamp(PERIOD);
        this.measureChartSeries = [];
        this.measureChartOptions = {
          chart: {
            id: `apexchart`,
            height: 425,
            width: "100%",
            stacked: false,
            zoom: {
              enabled: true,
              autoScaleYaxis: true,
            },
            animations: {
              enabled: false,
            },
            markers: {
              size: 0,
            },
            toolbar: {
              export: {
                csv: {
                  headerCategory: "Data",
                  filename: "Dados do gráfico",
                  dateFormatter(timestamp) {
                    return moment(timestamp).format("DD/MM/YYYY HH:mm");
                  },
                },
              },
              offsetY: -2,
            },
          },
          xaxis: {
            type: "datetime",
            labels: {
              show: true,
              // hideOverlappingLabels: true,
              datetimeUTC: false,
              format: "dd/MM/yyyy HH:mm",
              rotateAlways: false,
            },
          },
          stroke: {
            curve: "smooth",
            width: 2,
          },
          responsive: [],
          title: {},
          noData: {
            text: "Sem dados",
          },
          dataLabels: {
            enabled: false,
          },
          annotations: {
            yaxis: [],
          },
          tooltip: {
            x: {
              show: true,
              format: "dd/MM/yyyy HH:mm",
            },
            y: {
              // show: true,
              formatter: function (val) {
                if (this.measureChartType == "avg") {
                  return val + " (hrs)";
                } else if (val) {
                  return `${val.toFixed(2)}`;
                }
                return "0";
              },
            },
          },
          legend: {
            show: false,
          },
        };
        for (let i = 0; i < lenPerUnit; i++) {
          let info = dataPerUnit[0];
          // debugger
          let { data, measure, unit, type, pos, max, min } = info;

          if (this.measureChartType === "avg") {
            // let meditions = ["MÁXIMO", "MÍNIMO"];
            let meditions = ["MÍNIMO", "MÁXIMO"];
            this.measureChartOptions.chart.type = "bar";
            (this.measureChartOptions.responsive[0] = {
              breakpoint: 480,
              options: {
                title: {
                  text: "Leituras Max/Min em horas",
                },
              },
            }),
              (this.measureChartOptions.yaxis = {
                forceNiceScale: true,
                min: function (min) {
                  return min < 0 ? min : 0;
                },
                max: function (max) {
                  //Exibir máximo de 24 para eixo Y
                  // caso for molhamento foliar
                  return 24;
                },
                axisTicks: {
                  show: false,
                },
                logarithmic: false,
                opposite: false,
                axisBorder: {
                  show: false,
                  color: "#000",
                },
                labels: {
                  formatter: (val) => {
                    return val;
                  },
                  offsetX: 0,
                  align: "left",
                  rotate: 0,
                  style: {
                    fontSize: "10px",
                    colors: "#008FFB",
                  },
                },
                title: {
                  show: false,
                  style: {
                    color: "#008FFB",
                  },
                },
              });
            this.measureChartOptions.title = {
              text: `Leituras de mínimo e máximo da medição ${
                this.measureChartUnit !== ""
                  ? "( " + this.measureChartUnit + " )" + " em horas"
                  : ""
              }`,
              align: "left",
              offsetX: 10,
              offsetY: 15,
            };
            this.measureChartSeries[i] = {
              name: `Medição ${meditions[i]} - ${measure} (Horas)`,
              unit,
              data: data[i],
              c: "#007bff",
            };
          } else {
            this.measureChartSeries[i] = {
              name: `Medição ${pos + 1} - ${measure} (${unit})`,
              unit,
              data: this.organizeDataForCharts(data, filter),
              c: "#007bff",
            };
            this.measureChartOptions.title = {
              text: `Leituras ${
                this.measureChartUnit !== ""
                  ? "(" + this.measureChartUnit + ")"
                  : ""
              }`,
              align: "left",
              offsetX: 10,
              offsetY: 15,
            };
            this.measureChartOptions.chart.type = type;
            this.measureChartOptions.yaxis = {
              axisTicks: {
                show: false,
              },
              logarithmic: false,
              opposite: false,
              axisBorder: {
                show: false,
                color: "#000",
              },
              labels: {
                offsetX: 0,
                align: "left",
                rotate: 0,
                style: {
                  fontSize: "10px",
                  colors: "#008FFB",
                },
              },
              title: {
                show: false,
                style: {
                  color: "#008FFB",
                },
              },
            };
            this.measureChartOptions.annotations.yaxis.push(
              {
                y: max,
                borderColor: "#FFD61F",
                label: {
                  style: {
                    color: "#000",
                    background: "#FFD61F",
                  },
                  text: `máximo (${unit})`,
                },
              },
              {
                y: min,
                borderColor: "#C92D39",
                label: {
                  style: {
                    color: "#fff",
                    background: "#C92D39",
                  },
                  text: `mínimo (${unit})`,
                },
              },
            );
            let dataLogs = this.measureChartSeries[0].data.map((e) =>
              Number(e[1]),
            );
            let dataMin = Math.min(...dataLogs);
            if (dataMin < 0) {
              this.measureChartOptions.yaxis.min = dataMin - 10;
            } else if (dataMin > 0) {
              this.measureChartOptions.yaxis.min = 0;
            }
          }
          if (lenPerUnit == 1) {
            this.measureChartOptions.fill = { ...this.colorChart };
          }
        }
        setTimeout((_) => {
          this.loadingMeasureChart = false;
          this.hasMeasureChart = true;
          // wait.hide();
        }, 150);
      }
    },
    createEvent(note) {
      return monitChart
        .createEvent({ EQP: this.eqp, NAME: this.name, NOTE: note })
        .then((ret) => {
          if (!ret.status) throw ret.log || "Erro ao adicionar evento.";
          // Só re-busca e reprocessa os eventos (não usa callChart aqui: ele
          // também redesenha os gráficos ApexCharts, e chamá-lo de novo depois
          // do mount inicial pode falhar silenciosamente nesse trecho,
          // deixando organizeEventsInfo sem rodar e a tabela sem atualizar).
          return monitChart.create(
            this.buildChartRequestData(this.eqp, this.name, this.columns),
            this.controller,
          );
        })
        .then((ret) => {
          if (!ret.status) throw ret.log || "Erro ao atualizar eventos.";
          const rows =
            Array.isArray(ret.value) && Array.isArray(ret.value[0])
              ? ret.value[0]
              : ret.value;
          this.organizeEventsInfo(rows);
        });
    },
    changeDropdownLeft(option) {
      if (option) {
        this.selectedDropdownLeft = option;
        this.options = {};
        this.series = [];
        this.hasChart = false;
        this.period = "7d";
        if (
          this.selectedDropdownLeft === "m³" ||
          this.selectedDropdownLeft === "mm" ||
          this.selectedDropdownLeft === "kWh" ||
          this.selectedDropdownLeft === " kVArh"
        ) {
          this.selectedDropdownRight = null;
        }
        this.eqp == "SENSOR" && this.buildChartForLeftSideDropdown();
        if (this.selectedDropdownRight != null) {
          this.buildChartForRightSideDropdown();
        }
      }
    },
    formatDate(unix) {
      if (unix) {
        if (unix.length == 1) return moment(unix[0]).format("DD/MM/YYYY HH:mm");
        else
          return `${moment(unix[unix.length - 1]).format("DD/MM/YYYY HH:mm")}`;
      }
    },
    changeDataByPeriod(p) {
      if (!this.isVisibleMeasureChart) {
        this.period = p;
      }
      let now = moment();
      let today0h = moment({ hour: 0, minute: 0, seconds: 0, milliseconds: 0 });
      let period = null;
      switch (p) {
        case "7d":
          break;
        case "3d":
          period = today0h.subtract(3, "days").format("YYYY-MM-DD HH:mm");
          break;
        case "1d":
          period = today0h.subtract(1, "days").format("YYYY-MM-DD HH:mm");
          break;
        case "1h":
          period = now.subtract(1, "hours").format("YYYY-MM-DD HH:mm");
          break;
        case "30min":
          period = now.subtract(30, "minutes").format("YYYY-MM-DD HH:mm");
          break;
      }

      if (this.isVisibleMeasureChart) {
        this.buildMeasureChart(period);
      } else {
        this.selectedDropdownRight
          ? this.buildChartForRightSideDropdown(period)
          : this.buildChartForLeftSideDropdown(period);
      }
    },
    getTimestamp(datetime) {
      let dt = datetime.replace(/ /g, "T");
      return Math.round(new Date(dt).getTime());
    },
    buildChartForLeftSideDropdown(period) {
      let keys = Object.keys(this.info);
      if (keys.length && keys.includes("measuresPerUnit")) {
        // let name = this.info.name;
        let dataPerUnit = this.info.measuresPerUnit[this.selectedDropdownLeft];
        let unit = this.selectedDropdownLeft;
        let lenPerUnit = dataPerUnit.length;
        let filter = 0;
        if (period) filter = this.getTimestamp(period);
        this.series = [];
        this.options = {
          chart: {
            id: `apexchart`,
            height: 425,
            width: "100%",
            stacked: false,
            zoom: {
              enabled: true,
              autoScaleYaxis: true,
            },
            animations: {
              enabled: false,
            },
            markers: {
              size: 0,
            },
            events: {
              mounted: () => {
                if (!this.isChartMounted) {
                  this.isChartMounted = true;
                }
                return;
              },
            },
            toolbar: {
              export: {
                csv: {
                  headerCategory: "Data",
                  filename: "Dados do gráfico",
                  dateFormatter(timestamp) {
                    return moment(timestamp).format("DD/MM/YYYY HH:mm");
                  },
                },
              },
              offsetY: -2,
            },
          },
          xaxis: {
            type: "datetime",
            labels: {
              datetimeUTC: false,
              format: "dd/MM/yyyy HH:mm",
              rotateAlways: false,
            },
          },
          yaxis: [
            {
              axisTicks: {
                show: false,
              },
              logarithmic: false,
              opposite: false,
              axisBorder: {
                show: false,
                color: "#000",
              },
              labels: {
                offsetX: 0,
                align: "left",
                rotate: 0,
                style: {
                  fontSize: "10px",
                  colors: "#008FFB",
                },
              },
              title: {
                show: false,
                style: {
                  color: "#008FFB",
                },
              },
            },
          ],
          stroke: {
            curve: "smooth",
            width: [2, 2, 2],
          },
          title: {
            text: `Leituras ${unit !== "" ? "(" + unit + ")" : ""}`,
            align: "left",
            offsetX: 10,
            offsetY: 15,
          },
          noData: {
            text: "Sem dados",
          },
          dataLabels: {
            enabled: false,
          },
          annotations: {
            yaxis: [],
          },
          tooltip: {
            x: {
              show: true,
              format: "dd/MM/yyyy HH:mm",
            },
            y: {
              formatter: function (value) {
                if (value) {
                  return `${value.toFixed(2)}`;
                }
                return "0";
              },
            },
            markers: {
              size: 0,
              // style: "hollow",
            },
          },
          legend: {
            show: false,
          },
        };
        for (let i = 0; i < lenPerUnit; i++) {
          let info = dataPerUnit[i];
          let { data, type, pos, measure, unit, max, min } = info;
          this.options.chart.type = this.changeTypeChart(lenPerUnit, type);
          this.series[i] = {
            name: `Medição ${pos + 1} - ${measure} (${unit})`,
            unit,
            data: this.organizeDataForCharts(data, filter),
            c: "#007bff",
          };
          if (lenPerUnit == 1 && type != "bar" && !this.selectedDropdownRight) {
            this.options.fill = { ...this.colorChart };
          } else if (this.selectedDropdownRight) {
            this.options.fill = { ...this.colorChart };
            this.options.fill.opacity = 1;
          }
          this.options.annotations.yaxis.push(
            {
              y: max,
              borderColor: "#FFD61F",
              label: {
                style: {
                  color: "#000",
                  background: "#FFD61F",
                },
                text: `máximo (${unit})`,
              },
            },
            {
              y: min,
              borderColor: "#C92D39",
              label: {
                style: {
                  color: "#fff",
                  background: "#C92D39",
                },
                text: `mínimo (${unit})`,
              },
            },
          );
        }
        let logs = this.series[0].data.map((e) => Number(e[1]));
        let min = Math.min(...logs);
        if (min < 0) {
          this.options.yaxis[0].min = min - 10;
        } else if (min > 0) {
          this.options.yaxis[0].min = 0;
        }

        setTimeout((_) => {
          this.loading = false;
          this.hasChart = true;
        }, 150);
      }
    },
    changeTypeChart(lenPerUnit, type) {
      if (lenPerUnit > 1) {
        return "line";
      } else if (type && type != "area") {
        return type;
      } else if (
        type &&
        type === "area" &&
        this.selectedDropdownRight === null
      ) {
        return "area";
      } else if (type && type === "area" && this.selectedDropdownRight) {
        return "line";
      } else if (!type && this.info.type) {
        return "line";
      }
    },
    buildChartForRightSideDropdown(period) {
      let keys = Object.keys(this.info);
      period
        ? this.buildChartForLeftSideDropdown(period)
        : this.buildChartForLeftSideDropdown();
      if (keys.length && keys.includes("measuresPerUnit")) {
        // let name = this.info.name;
        let dataPerUnit = this.info.measuresPerUnit[this.selectedDropdownRight];
        let unit = this.selectedDropdownRight;
        let lenPerUnit = dataPerUnit.length;
        let filter = 0;
        if (period) filter = this.getTimestamp(period);
        let series = [];
        let options = {
          yaxis: {
            // seriesName: this.serieNameChart,
            opposite: false,
            axisTicks: {
              show: false,
            },
            axisBorder: {
              show: false,
              color: "#28a745",
            },
            labels: {
              offsetX: -10,
              style: {
                fontSize: "10px",
                colors: "#28a745",
              },
            },
            title: {
              show: false,
              style: {
                color: "#28a745",
              },
            },
            tooltip: {
              enabled: false,
              x: {
                show: true,
                format: "dd/MM/yyyy HH:mm",
              },
              y: {
                formatter: function (value) {
                  if (value && value >= 0) {
                    return `${value.toFixed(2)} ${unit}`;
                  }
                  return "";
                },
              },
              markers: {
                size: 0,
                style: "hollow",
              },
              // shared: true,
            },
          },
        };
        for (let i = 0; i < lenPerUnit; i++) {
          let info = dataPerUnit[i];
          let { data, type, pos, measure, unit } = info;
          options.type = this.changeTypeChart(lenPerUnit, type);
          series[i] = {
            name: `Medição ${pos + 1} - ${measure} (${unit})`,
            type: this.changeTypeChart(lenPerUnit, type),
            unit,
            data: data.length ? data.filter((e) => e[0] > filter) : data,
            c: "#4ba05f",
          };
        }
        if (series.length > 1) {
          series.forEach((e) => {
            this.series.push(e);
          });
        } else {
          this.series.push(series[0]);
        }
        this.options.yaxis.push(options.yaxis);
      }
    },
    organizeDataForCharts(data, filter) {
      let result;
      try {
        if (data.length) {
          result = data.filter((e) => e[0] > filter);
          if (!result.length > 0) {
            throw `Não existe dados para o período de ${this.period} especificado.`;
          }
          return result.length ? result : [];
        } else {
          return data;
        }
      } catch (error) {
        alert(error);
        return [];
      }
    },
    organizeEventsInfo(logs) {
      let formatData = [];
      logs = logs.filter((log) => {
        return !!log.NOTE;
      });
      formatData = logs.map(({ NOTE, TIME }) => {
        return { NAME: TIME, VALUE: NOTE };
      });
      formatData.sort(function (a, b) {
        var c = new Date(a.NAME);
        var d = new Date(b.NAME);
        return d - c;
      });
      this.TabulatorData = formatData;
    },
    createMeasureChart(PERIOD = null) {
      try {
        let { info } = this.info;
        let [{ NAME }] = this.columns;
        if (this.measureChartType === "avg") {
          organizeLogMaxMin(info, NAME, this.columns).then((logs) => {
            this.MeasureChartInfo = logs.value;
            this.buildMeasureChart();
          });
        } else {
          let columns = this.columns.filter(
            (col) => col.POS === this.measureChartPosition,
          );
          organizeLog(info, this.eqp, NAME, columns, "unit_measure").then(
            (logs) => {
              this.MeasureChartInfo = logs.value;
              this.buildMeasureChart(PERIOD);
            },
          );
        }
      } catch (err) {
        this.loadingMeasureChart = false;
        this.hasMeasureChart = false;
        // wait.hide();
        console.error(err);
        this.noChartWarning = "Não foi possível desenhar o gráfico.";
      }
    },
    buildChartRequestData(EQP, NAME, columns) {
      const START = moment()
        .subtract(1, "week")
        .hours(0)
        .minutes(0)
        .format("YYYY-MM-DD HH:mm");
      // Com segundos: truncar em "HH:mm" faz o refresh logo após um insert
      // manual (TIME = NOW(), com segundos) excluir a própria linha recém-
      // gravada da consulta (TIME <= END truncado fica menor que o TIME real).
      const END = moment().format("YYYY-MM-DD HH:mm:ss");
      return {
        EQP,
        NAME,
        COLUMN: EQP != "SENSOR" ? columns : "UNIT",
        CONDITION:
          EQP != "SENSOR"
            ? "where"
            : {
                TYPES: columns.map((e) => e.TYPE),
                UNITS: columns.map((e) => e.UNIT),
              },
        START,
        END,
      };
    },
    callChart(EQP, NAME, columns) {
      let data = this.buildChartRequestData(EQP, NAME, columns);
      monitChart
        .create(data, this.controller)
        // monitChartCreate() //Mock
        .then(async (ret) => {
          let result = ret;
          if (result.status) {
            const logs = await organizeLog(
              result,
              EQP,
              NAME,
              this.columns,
              null,
              this.area,
            ).catch((err) => Promise.reject(err));
            const eventsLogs = [...result.value[0]];
            return {
              logs,
              eventsLogs,
            };
          } else {
            alert(result.log, "w");
            throw result.log;
          }
        })
        .then(({ logs, eventsLogs }) => {
          if (logs.status) {
            this.info = logs.value;
            this.buildChartForLeftSideDropdown();
            if (this.selectedDropdownRight) {
              this.buildChartForRightSideDropdown();
            }
          } else {
            this.loading = false;
            this.hasChart = false;
            this.noChartWarning = logs.log;
          }
          return eventsLogs;
        })
        .then((eventsLogs) => this.organizeEventsInfo(eventsLogs))
        .catch((err) => {
          this.loading = false;
          this.hasChart = false;
          console.error(err);
          this.noChartWarning = "Não foi possível desenhar o gráfico.";
        });
    },
  },
};
</script>

<style scoped>
.grafics {
  min-height: 425px;
}
.chart-div {
  position: relative;
}
.highlights h4 {
  margin: 0;
}

.highlights .hl-detail {
  display: block;
  font-size: 12px;
  color: #777;
}

.container-buttons-left {
  display: flex;
  flex-wrap: wrap;
  align-content: flex-start;
  /* justify-content: space-between; */
}
.highlights div:first-child {
  margin-bottom: 4px;
}
.highlights .card-name {
  margin-bottom: 8px;
  padding-bottom: 4px;
  font-size: 1.2em;
  padding: 4px 2px;
  text-align: center;
}
.card-container {
  border: solid 1px #dedede;
  padding: 0 -14px;
}
.label {
  display: none;
}
@media (max-width: 767px) {
  .container-dropdown {
    padding-top: 0em;
  }
  .btn-left {
    padding: 0;
  }
  .container-buttons .dropdown + .dropdown {
    margin-top: 4px;
    /* display: flex; */
    /* justify-content: space-between; */
  }
}
</style>
